import { makeStyles } from "@fluentui/react-components";

export const useGenericPopoverPanelStyles = makeStyles({
  popOverTrigger: {
    position: "relative",
    minWidth: "32px",
  },
  popOverTriggerActive: {
    zIndex: "1000",
    backgroundColor: "white",
    borderRadius: "50%",
  },
  popOverTriggerBadge: {
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  iconStyle: {
    display: "inline-flex",
    alignItems: "center",
    width: "20px",
    height: "20px",
  },
});
